import { createContext, useContext, useEffect, useState } from "react";
import { getWarningsForUser, markWarningAsRead } from "../../services/warning";
import { useSelector } from "react-redux";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

export const NotificationProvider = ({ children }) => {
  const loggedInUser = useSelector((state) => state.auth.user);

  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchNotifications = async () => {
    if (!loggedInUser?.id || !loggedInUser?.role) return;

    setLoading(true);
    try {
      const res = await getWarningsForUser(loggedInUser.id, loggedInUser.role);
      setNotifications(res);
    } catch (err) {
      console.error("Fetch notifications error:", err);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (id) => {
    try {
      await markWarningAsRead(id);
      setNotifications((prev) =>
        prev.map((n) =>
          n.id === id ? { ...n, isRead: true, readAt: new Date() } : n
        )
      );
    } catch (err) {
      console.error("Mark as read error:", err);
    }
  };

  const unreadCount = notifications.filter((n) => !n.isRead).length;

  useEffect(() => {
    fetchNotifications();
    // eslint-disable-next-line
  }, [loggedInUser]);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        loading,
        fetchNotifications,
        markAsRead,
        unreadCount,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
